import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoPreviewContainer = props => /*#__PURE__*/_jsx(Fragment, {
  children: /*#__PURE__*/_jsx("div", {
    className: "video-container-background",
    children: /*#__PURE__*/_jsx("div", {
      className: "video-container",
      children: props.children
    })
  })
});
export default VideoPreviewContainer;